export default __webpack_public_path__ + "static/design-phone-01ea7a74243ac93461171545129469fa.png";